import React from "react";
import styles from "./Studio.module.scss";
import studioImage from "../../../assets/images/studio-image.jpg";

const Studio = () => {
  return (
    <div className={`studioRef ${styles.artistStudio}`}>
      <h2 className={styles.title}>Studio</h2>
      <div className={styles.studioContainer}>
        <div className={styles.image}>
          <img src={studioImage} alt="Studio" />
        </div>
        <div className={styles.image}>
          <img src={studioImage} alt="Studio" />
        </div>
        <div className={styles.image}>
          <img src={studioImage} alt="Studio" />
        </div>
        <div className={styles.image}>
          <img src={studioImage} alt="Studio" />
        </div>
      </div>
      <div className={styles.loadMore}>
        <button>Load More</button>
      </div>
    </div>
  );
};

export default Studio;
